import React, { type FC, useState } from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import type { ExternalCollaboratorsSpaceInformationMessageBannerProps } from '../types';

import { ExternalCollaboratorsSpaceInformationMessage } from './ExternalCollaboratorsSpaceInformationMessage';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	backgroundColor: token('color.background.accent.gray.subtlest'),
	padding: `${token('space.200')}`,
	borderRadius: '3px',
	overflow: 'hidden',
});

export const ExternalCollaboratorsSpaceInformationMessageBanner: FC<
	ExternalCollaboratorsSpaceInformationMessageBannerProps
> = (props) => {
	const [shouldShowExternalCollaborators, setShouldShowExternalCollaborators] =
		useState<boolean>(false);

	const onExternalCollaborationLoadComplete = (props) => {
		setShouldShowExternalCollaborators(props?.guestCount > 0);
	};

	const onExternalCollaborationLoadError = () => {
		setShouldShowExternalCollaborators(false);
	};

	const ParentWrapper = props?.wrapper;

	return (
		<ParentWrapper hidden={!shouldShowExternalCollaborators}>
			<Wrapper>
				<ExternalCollaboratorsSpaceInformationMessage
					{...props}
					onLoadComplete={onExternalCollaborationLoadComplete}
					onLoadError={onExternalCollaborationLoadError}
				/>
			</Wrapper>
		</ParentWrapper>
	);
};
